(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hdb-scroll-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hdb-scroll-hero')) {
    customElements.define('hdb-scroll-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const cta = this.querySelector('[data-hdb-cta]');
        const label = this.querySelector('[data-hdb-cta-text]');
        this.querySelectorAll('[data-hdb-need]').forEach(button => {
          button.addEventListener('click', () => {
            if (!button.dataset.href || !cta || !label) return;
            this.querySelectorAll('[data-hdb-need]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            cta.href = button.dataset.href;
            label.textContent = button.dataset.label;
          }, { signal });
        });
        if (this.dataset.motion !== 'true') return;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.stage = this.querySelector('.hdb-motion__stage');
        this.visible = false;
        const update = () => {
          this.frame = 0;
          if (!this.visible || this.reducedMotion.matches || !this.stage) return;
          const rect = this.stage.getBoundingClientRect();
          const start = Math.max(0, rect.top + window.scrollY - window.innerHeight * .35);
          const progress = Math.max(0, Math.min(1, (window.scrollY - start) / Math.max(1, rect.height * .75)));
          this.style.setProperty('--hdb-x', `${-22 + progress * 36}px`);
          this.style.setProperty('--hdb-y', `${-12 + progress * 28}px`);
          this.style.setProperty('--hdb-turn', `${-22 + progress * 30}deg`);
          this.style.setProperty('--hdb-scale', String(1.08 - progress * .15));
        };
        const schedule = () => {
          if (!this.frame && this.visible && !this.reducedMotion.matches) this.frame = requestAnimationFrame(update);
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          schedule();
        });
        this.observer.observe(this);
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        window.addEventListener('pageshow', schedule, { signal });
        this.reducedMotion.addEventListener('change', schedule, { signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
